import gql from 'graphql-tag';

export const getEventSuperSleuthListQuery = gql`
  query allEventSuperSleuths(
    $page: Int
    $perPage: Int
    $sortField: String
    $sortOrder: String
    $filter: EventSuperSleuthFilter
  ) {
    items: allEventSuperSleuths(
      page: $page
      perPage: $perPage
      sortField: $sortField
      sortOrder: $sortOrder
      filter: $filter
    ) {
      id
      evidence
      id
      isSuperSleuth
      isIntentional
      sleuthName
      suspect {
        id
        murderBoxChecked
      }
      suspectName
      createdAt
      updatedAt
      deletedAt
      __typename
    }
    total: _allEventSuperSleuthsMeta(page: $page, perPage: $perPage, filter: $filter) {
      count
      __typename
    }
  }
`;
